import { getActiveStep } from '@console/common/getActiveStep';
import { connect } from 'react-redux';
import type { NavigateFunction } from 'react-router';
import { updateMessageCardUsing } from '../../actions/actions';
import type { AppThunkAction, AppThunkDispatch } from '../../actions/thunkType';
import MessageCardUsing from '../../components/common/MessageCardUsing';
import type { AppState } from '../../reducers';

const onChangeMessageCardUsing =
  (messageCardUsing: string): AppThunkAction<void> =>
  (dispatch, getState) => {
    const { selectedGiftConfigIndex } =
      getState().selectedProjectDraft.projectJson;
    const boolMessageCardUsing = messageCardUsing === 'true';

    dispatch(
      updateMessageCardUsing(boolMessageCardUsing, selectedGiftConfigIndex)
    );
  };

const handleStepNextFromParent =
  (navigate: NavigateFunction): AppThunkAction<void> =>
  (dispatch, getState) => {
    const { parentStep, childStep } = getActiveStep();

    if (isMessageCardUsing(getState())) {
      navigate(
        `${location.pathname}?parentStep=${parentStep}&childStep=${
          childStep + 1
        }`
      );
    } else {
      navigate(`${location.pathname}?parentStep=${parentStep}&childStep=${0}`);
    }
  };

const isMessageCardUsing = (state: AppState): boolean => {
  const { selectedGiftConfigIndex } = state.selectedProjectDraft.projectJson;
  const { messageCardUsing } =
    state.selectedProjectDraft.projectJson.giftConfigs[selectedGiftConfigIndex];
  return messageCardUsing;
};

const mapStateToProps = (state: AppState) => ({
  messageCardUsing:
    state.selectedProjectDraft.projectJson.giftConfigs[
      state.selectedProjectDraft.projectJson.selectedGiftConfigIndex
    ].messageCardUsing
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  onChangeMessageCardUsing: (event: GenericChangeEvent<string>) =>
    dispatch(onChangeMessageCardUsing(event.target.value)),
  handleStepNextFromParent: (navigate: NavigateFunction) =>
    dispatch(handleStepNextFromParent(navigate))
});

export type MessageCardUsingPropsMappedFromState = ReturnType<
  typeof mapStateToProps
>;
export type MessageCardUsingPropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(MessageCardUsing);
